import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import './global';

require('!css-loader!less-loader!./assets/less/common.less');

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
